import { render } from "./SpoilerEye.vue?vue&type=template&id=255a25ed&ts=true"
import script from "./SpoilerEye.vue?vue&type=script&lang=ts"
export * from "./SpoilerEye.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__